<template>
  <div class="animate-pulse">
    <ul
      class="scrollbar-hidden mb-6 flex w-3/4 gap-2 overflow-y-visible overflow-x-scroll md:mb-10 md:gap-5"
    >
      <UiButton
        v-for="item in 4"
        :key="item"
        tag="li"
        severity="tertiary"
        class="w-1/4 px-2 py-1 text-left md:flex-row md:items-center md:gap-1 md:px-4 md:py-2 md:text-center"
      >
        <div class="h-7 w-full bg-secondary" />
      </UiButton>
    </ul>
    <div class="relative py-5 md:py-0">
      <ul class="grid grid-cols-1 gap-x-6 gap-y-4 md:grid-cols-3 md:gap-y-12">
        <li v-for="item in 10" :key="item + 'card'" class="bg-transparent md:p-0">
          <EventSeancesCardSkeleton />
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { EventSeancesCardSkeleton } from '@/5_entities/Event'
import { UiButton } from '@/6_shared/ui'
</script>
